import { TranscriptorConsultation } from '../config';

import { isUploadNotCompleted } from './uploadNotCompleted';

export const isConsultationOpenable = (
  consultation: Pick<TranscriptorConsultation, 'status' | 'error'>,
): boolean =>
  consultation.status !== 'created' && !isUploadNotCompleted(consultation);
